import React from 'react';
import { IconProps } from './types';

const LevelIntermediateVertical: React.FC<IconProps> = ({
  className,
  size = 32,
  color = '#181B32',
  ignoreColor,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="4"
      y="10.4"
      width="3"
      height="9.6"
      rx="1.5"
      fill={!ignoreColor ? color : undefined}
    />
    <path
      fill={!ignoreColor ? color : undefined}
      d="M10.6973 8.69995C10.6973 7.87153 11.3688 7.19995 12.1973 7.19995C13.0257 7.19995 13.6973 7.87152 13.6973 8.69995V18.5C13.6973 19.3284 13.0257 20 12.1973 20C11.3688 20 10.6973 19.3284 10.6973 18.5V8.69995Z"
    />
    <path
      opacity="0.2"
      d="M17.3955 5.5C17.3955 4.67157 18.0671 4 18.8955 4C19.7239 4 20.3955 4.67157 20.3955 5.5V18.5C20.3955 19.3284 19.7239 20 18.8955 20C18.0671 20 17.3955 19.3284 17.3955 18.5V5.5Z"
      fill="#8D8D9D"
    />
  </svg>
);

export default LevelIntermediateVertical;
